import { render } from "./PosterSoon.vue?vue&type=template&id=2d45a18c"
import script from "./PosterSoon.vue?vue&type=script&lang=js"
export * from "./PosterSoon.vue?vue&type=script&lang=js"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__